import { useState } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import EmissionsBySourceSubentity from './EmissionsBySourceSubentity';

import { CategoryTableTitle } from '../../styledComponents/GlobalStyle';

const EmissionsBySourceEntity = ({ entity, subentities }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <tr style={{ height: '10px' }}>
        <td colSpan="5" style={{ borderBottom: 'none', padding: 0 }}></td>
      </tr>

      <tr className={`title-row-${entity?.name?.split(' ').join('').replace(':', '-')}`} style={{ textAlign: 'left' }}>
        <CategoryTableTitle className='table-title' colSpan='5' style={{ position: 'relative' }}>
          {entity.name}
          <span 
            onClick={() => setIsExpanded(!isExpanded)}
            style={{ 
              top: '0px',
              right: '2px',
              fontSize: '16px',
              cursor: 'pointer',
              fontWeight: 'bold',
              userSelect: 'none',
              padding: '8px 14px',
              position: 'absolute',
            }}
          >
            {isExpanded ? '-' : '+'}
          </span>
        </CategoryTableTitle>
      </tr>

      {isExpanded && subentities?.map((subentity, index) => (
        <EmissionsBySourceSubentity key={index} entity={entity} subentity={subentity} />
      ))}
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { data } = state.consumption;

  const { subentities, entities } = state;

  const { entityID } = ownProps;

  const entitySubentities = data?.[entityID] && Object.keys(data[entityID]);

  const entity = _.find(entities, { id: entityID });

  const filteredSub = subentities && subentities.filter(({ id }) => entitySubentities?.includes(String(id)));

  const neededSubentities = subentities && _.orderBy(filteredSub, ['name']);

  return {
    entity,
    subentities: neededSubentities,
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(EmissionsBySourceEntity);